import { Divider, List } from '@mui/material'
import React, { ReactElement } from 'react'
import { useLocation } from 'react-router'
import { RoutesArray } from 'ui/components/Navigation/types'

import SidebarItem from '../SidebarItem/SidebarItem'
import SubMenuItem from '../SubMenuItem/SubMenuItem'

type DrawerItemsProps = {
  routes: RoutesArray
  drawerOpen: boolean
  onItemNavigate?: () => void
}

function DrawerItems({ routes, drawerOpen, onItemNavigate }: DrawerItemsProps): ReactElement {
  const location = useLocation()
  return (
    <>
      <Divider />
      <List>
        {routes.map((item, index) => {
          if (item.redirect || item.notInSidemenu) {
            return null
          }
          if (item.children) {
            if (item.children.length === 0) {
              return null
            }
            if (item.children.length === 1) {
              return item.children.map((child, i) => {
                return (
                  <SidebarItem
                    key={`${child.sidebarName ?? ''}-${index}-${i}`}
                    active={child.path === location.pathname}
                    item={child}
                    sideBarOpen={drawerOpen}
                    onNavigate={onItemNavigate}
                  />
                )
              })
            } else {
              return (
                <SubMenuItem
                  item={item}
                  key={`${item.sidebarName ?? ''}-${index}`}
                  sideBarOpen={drawerOpen}
                  onNavigate={onItemNavigate}
                />
              )
            }
          } else {
            return (
              <SidebarItem
                key={`${item.sidebarName ?? ''}-${index}`}
                active={location.pathname.includes(item.path)}
                item={item}
                sideBarOpen={drawerOpen}
                onNavigate={onItemNavigate}
              />
            )
          }
        })}
      </List>
    </>
  )
}

export default React.memo(DrawerItems)
